
export class UnsubModel{
    public name: string;
    public description: string;
    public id: Number;
    constructor(name:string,description:string,id:Number){
        this.name =  name;
        this.description = description;
        this.id = id;
    }
}